import type { TourSpec } from "./types";

export const settingsPersonalTour: TourSpec = {
  id: "settings-personal",
  version: 1,
  buildSteps: (t) => [
    {
      target: '[data-tour="personal-filter-preview"]',
      title: t("settingsPersonal.preview.title"),
      content: t("settingsPersonal.preview.body"),
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: '[data-tour="personal-range-sliders"]',
      title: t("settingsPersonal.ranges.title"),
      content: t("settingsPersonal.ranges.body"),
      placement: "top",
    },
    {
      target: '[data-tour="personal-dashboard-config"]',
      title: t("settingsPersonal.dashboard.title"),
      content: t("settingsPersonal.dashboard.body"),
      placement: "top",
    },
    {
      target: '[data-tour="personal-item-matching"]',
      title: t("settingsPersonal.matching.title"),
      content: t("settingsPersonal.matching.body"),
      placement: "top",
    },
    {
      target: '[data-tour="personal-save-defaults"]',
      title: t("settingsPersonal.save.title"),
      content: t("settingsPersonal.save.body"),
      placement: "top",
    },
  ],
};
